export default __webpack_public_path__ + "static/diabetes_conslt_banner-875254e88cfb12b16cd6061ae7304368.png";